export const options_readingPane_quickSetting_label = "vtd";
export default {options_readingPane_quickSetting_label};